module.exports = __webpack_public_path__ + "static/media/ic_snapshot_disable.ff5e1198.svg";